// extracted by mini-css-extract-plugin
module.exports = {"title":"title--+JP+u","contactData":"contactData--jrFPv","subContent":"subContent--1siD-"};